import React from 'react';

import WaitingList from './WaitingList';

const BarberWaitingList = props => (
  <WaitingList heading="Barber waiting list" {...props} />
);

export default BarberWaitingList;
